import(/* webpackMode: "eager", webpackExports: ["FooterWithSEO"] */ "/home/runner/work/settlin.in/settlin.in/components/footer-with-seo.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Header"] */ "/home/runner/work/settlin.in/settlin.in/components/header/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/settlin.in/settlin.in/components/search/compare/comparison-tray.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MinimizedComparisonBadge"] */ "/home/runner/work/settlin.in/settlin.in/components/search/compare/minimized-comparison-badge.tsx");
